var symphony = symphony || {};

;(function() {

	symphony.showOnHover = function() {

		var html = $('html'),
			showOnHoverTrigger = $('.js-showOnHoverParent');

		if(html.hasClass('touchevents') && $('window').width() <= 768){
			return;
		}
		showOnHoverTrigger.hover(
			function() {
				$(this).find('.js-showOnHover').addClass('isShown');
			}, function() {
				$(this).find('.js-showOnHover').removeClass('isShown');
		});

	};


})();